<template>
  <div class="hello">
    <div class="header">
      <van-nav-bar title="缴费管理" left-text="返回" @click-left="backJump" left-arrow>
        <template #right>
          <van-icon name="ellipsis" />
        </template>
      </van-nav-bar>
    </div>
    <div class="content">
      <div class="dg" v-for="i in trans">
        <div class="bod">
          <img v-if="i.devType == '1'" src="../assets/water.png" style="width:40px;height: 40px;float: left;margin-top: 25px;" alt="">
          <img v-else src="../assets/dian.png" style="width:40px;height: 40px;float: left;margin-top: 25px;" alt="">
          <div style="margin-top: 25px;float: left;margin-left: 12px;">
            <span v-if="i.devType == '1'">水费</span>
            <span v-else>电费</span>
            |
            <span>{{i.houseHoldNumber}}</span>
            <div style="margin-top: 5px;">
              <span style="font-size: 12px;color: #8e8e8e;margin-top: 2px;">{{i.actName}}</span>
            </div>
          </div>
          <div style="float: right;margin-top: 36px;">
            <van-icon style="margin-left: 10px;" @click="dete(i.id)" name="delete-o" size="30" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {information, informationDel} from '../common/api/management'
import jump from "../common/jump";
export default {
  data() {
    return {
      id:'',
      name:'',
      trans:[
      ],
    }
  },
  mounted() {
    information().then((response)=>{
      console.log(response)
      this.trans = response.data.items

    })
  },
  methods:{
    backJump(){
      this.$destroy()
      jump.$emit('back')
      this.$router.go(-1)
    },
    dete(houseHold){
      console.log(houseHold)
      console.log(this.$cookies.get("token"))
      this.$dialog.confirm({
        title: '',
        message: '确认删除吗'
      })
          .then(() => {
            informationDel({id:houseHold}).then((response)=>{
              console.log(response)
              if(response.msg == "操作成功"){
                console.log("yyy")
                this.$toast.success("删除成功")
                this.$router.push({path:'/index'})
              }
              else{
                this.$toast(response.msg)
              }
            })
          }).catch((err)=> {
        console.log(err)
      })
    }
  },
  destroyed() {
    this.trans = []
  }
}
</script>

<style scoped>
.dg{
  width: 90%;
  border: 1px solid #dee1e5;
  box-shadow: #dee1e5 0px 0px 1px 1px;
  margin: 0 auto;
  border-radius: 10px;
  margin-top: 30px;
  height: 100px;
}
.bod{
  width: 80%;
  margin: 0 auto;
  display: flex;
  justify-content: space-start;
  align-items: center;
}
</style>
